module.exports = __webpack_public_path__ + "components/modal-app-popup/static/app-icon-bd2ccd2ebca3a817be30d826dc5fe5c6.svg";